import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { CloseCircleOutlined } from "@ant-design/icons";
import userActions from "../../../redux/auth/actions";
import "./index.css";

const Quiz = () => {
  const [isOpenQuiz, setIsOpenQuiz] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(0);

  const { userSurveyStatus, userId } = useSelector(
    (state) => state.authReducer
  );
  const { editQuiz } = userActions;

  // Quiz options
  // userSurveyStatus === 0 cancelled
  // userSurveyStatus === 1 filled
  // userSurveyStatus === 2 show

  useEffect(() => {
    if (userSurveyStatus === 2) {
      setIsOpenQuiz(true);
    }
  }, [userSurveyStatus]);

  const dispatch = useDispatch();

  const closeQuizModal = () => {
    if (userId !== null) {
      dispatch(editQuiz(0, userId));
      setIsOpenQuiz(false);
    }
  };

  useEffect(() => {
    if (isSubmitted === 2) {
      if (userId !== null) {
        dispatch(editQuiz(1, userId));
        setIsOpenQuiz(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitted]);

  return (
    <Modal
      open={isOpenQuiz}
      footer={null}
      className="quiz-modal"
      onCancel={closeQuizModal}
      closeIcon={<CloseCircleOutlined />}
      width={
        window.innerWidth < 760
          ? "100%"
          : window.innerWidth > 1350
          ? "40%"
          : "65%"
      }
    >
      <iframe
        title="Quiz"
        // src="https://docs.google.com/forms/d/e/1FAIpQLSdz3tus0Dp9bJQ_4EuYr0gKvynTnDPgWe0PgqYF3HDw8vDhWw/viewform?embedded=true"
        src="https://banner.unrealsoft.bg/"
        width="100%"
        height="750"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        onLoad={
          // first time when we are here we load the form, and second time we load the submitted message
          () => {
            setIsSubmitted(isSubmitted + 1);
          }
        }
      >
        Зарежда се…
      </iframe>
      {/* <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Button type="primary" onClick={closeQuizModal}>
          Затвори
        </Button>
      </div> */}
    </Modal>
  );
};

export default Quiz;
